// Joins class names, skipping falsy values. Primitives compose variant classes
// with this instead of pulling in a class-merging dependency.
export default function cn(...parts) {
  return parts.flat(Infinity).filter(Boolean).join(" ");
}

// Keyboard focus indicator shared by every interactive primitive (DESIGN.md ›
// Accessibility): a 2 px ring in the focus token, offset from the control.
export const focusRing =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus";
